export const JETBRAINS_PLUGIN_URL = "https://plugins.jetbrains.com/plugin/26860-sweep-ai";